import '../scss/Shop.css';

const Shop = () => {
    return ( 
        <section id="shop">
            <figure>
            <img src="../images/shop.png" alt="" />
            </figure>
            <article>
                <div>
                    <h1>COMING SOON</h1>
                    <h1>STAY TUNED!</h1>
                </div>
            </article>
        </section>
     );
}
 
export default Shop;